<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-select
          ref="projectSelect"
          v-model="projectId"
          placeholder="请选择项目名称"
          style="width: 250px"
          size="mini"
          clearable
          filterable
        >
          <el-option
            v-for="item in projects"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>

        <span style="margin-right: 20px"></span>

        <el-input
          style="width: 250px; margin-right: 10px"
          prefix-icon="el-icon-edit"
          v-model="custName"
          size="mini"
          placeholder="请输入客户名称"
          clearable
        >
        </el-input>

        <span style="margin-right: 10px"></span>

        <!-- <el-select
          v-model="createMan"
          size="mini"
          style="width: 130px"
          placeholder="项目销售人员"
          clearable
          v-if="qx"
        >
          <el-option
            v-for="item in createMans"
            :key="item.id"
            :label="item.uname"
            :value="item.id"
          >
          </el-option>
        </el-select> -->

        <span style="margin-right: 20px"></span>

        <el-date-picker
          v-model="rqScope"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          style="margin-left: 10px"
          size="mini"
        >
          搜索
        </el-button>
      </div>
      <!-- 右边工具 -->
      <div>
        <!-- <el-checkbox v-model="gd">固定项目列</el-checkbox> -->
        <el-button
          type="success"
          @click="downloadExcel"
          style="margin-left: 10px"
          size="mini"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button
          type="success"
          icon="el-icon-refresh"
          @click="shuaxin"
          size="mini"
          >刷新</el-button
        >
      </div>
    </div>
    <!-- 表格  -->
    <div style="margin-top: 20px">
      <el-table
        v-loading="loading"
        :data="reportData"
        border
        stripe
        height="calc(100vh - 250px)"
        id="mytable"
        size="mini"
        element-loading-text="拼命加载中"
        :row-style="{ height: '60px' }"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        @row-dblclick="DetailRecordView"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%; font-size: 14px"
      >
        <!-- 这里是下拉 展开行 -->
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- <div style="margin-left: 10px; margin-top: 10px;"> 0、采购成本细项:</div>
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="服务器">
								<span class="myfont">{{ props.row.bm1 }}</span>
							</el-form-item>
							<el-form-item label="交换机">
								<span class="myfont">{{ props.row.bm2 }}</span>
							</el-form-item>
							<el-form-item label="无线AP">
								<span class="myfont">{{ props.row.bm3 }}</span>
							</el-form-item>
							<el-form-item label="堡垒机">
								<span class="myfont">{{ props.row.bm4 }}</span>
							</el-form-item>
							<el-form-item label="防火墙">
								<span class="myfont">{{ props.row.bm5 }}</span>
							</el-form-item>
							<el-form-item label="一体机">
								<span class="myfont">{{ props.row.bm6 }}</span>
							</el-form-item>
							<el-form-item label="大屏设备">
								<span class="myfont">{{ props.row.bm7 }}</span>
							</el-form-item>
							<el-form-item label="软件采购">
								<span class="myfont">{{ props.row.bm8 }}</span>
							</el-form-item>
							<el-form-item label="授权采购">
								<span class="myfont">{{ props.row.bm9 }}</span>
							</el-form-item>
							<el-form-item label="其它">
								<span class="myfont">{{ props.row.bm10 }}</span>
							</el-form-item>
							<el-form-item label="小计">
								<span class="myfont">{{ props.row.bmxj }}</span>
							</el-form-item>
						</el-form> -->

            <div style="margin-left: 10px; margin-top: 10px">
              1、费用成本细项:
            </div>
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="人工费">
                <span class="myfont">{{ props.row.cost1 }}</span>
              </el-form-item>
              <el-form-item label="公关招待费">
                <span class="myfont">{{ props.row.cost2 }}</span>
              </el-form-item>
              <el-form-item label="差旅费">
                <span class="myfont">{{ props.row.cost3 }}</span>
              </el-form-item>
              <el-form-item label="交通费">
                <span class="myfont">{{ props.row.cost4 }}</span>
              </el-form-item>
              <el-form-item label="投标服务费">
                <span class="myfont">{{ props.row.cost5 }}</span>
              </el-form-item>
              <el-form-item label="车辆使用费">
                <span class="myfont">{{ props.row.cost6 }}</span>
              </el-form-item>
              <el-form-item label="办公费">
                <span class="myfont">{{ props.row.cost7 }}</span>
              </el-form-item>
              <el-form-item label="运输费">
                <span class="myfont">{{ props.row.cost8 }}</span>
              </el-form-item>
              <el-form-item label="广告宣传费">
                <span class="myfont">{{ props.row.cost9 }}</span>
              </el-form-item>
              <el-form-item label="邮电通讯费">
                <span class="myfont">{{ props.row.cost10 }}</span>
              </el-form-item>
              <el-form-item label="咨询会务费">
                <span class="myfont">{{ props.row.cost11 }}</span>
              </el-form-item>
              <el-form-item label="维修费">
                <span class="myfont">{{ props.row.cost12 }}</span>
              </el-form-item>
              <el-form-item label="奖金提成">
                <span class="myfont">{{ props.row.cost13 }}</span>
              </el-form-item>
              <el-form-item label="技术服务费">
                <span class="myfont">{{ props.row.cost15 }}</span>
              </el-form-item>
              <el-form-item label="投标保证金">
                <span class="myfont">{{ props.row.money1 }}</span>
              </el-form-item>
              <el-form-item label="其他费用">
                <span class="myfont">{{ props.row.cost14 }}</span>
              </el-form-item>
              <el-form-item label="小计">
                <span class="myfont">{{ props.row.costxj }}</span>
              </el-form-item>
            </el-form>

            <div style="margin-left: 10px; margin-top: 10px">
              2、费用税金细项:
            </div>
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="增值税及附加">
                <span class="myfont">{{ props.row.rate1 }}</span>
              </el-form-item>
              <el-form-item label="企业所得税">
                <span class="myfont">{{ props.row.rate2 }}</span>
              </el-form-item>
              <el-form-item label="印花税">
                <span class="myfont">{{ props.row.rate3 }}</span>
              </el-form-item>
              <el-form-item label="小计">
                <span class="myfont">{{ props.row.ratexj }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <!-- 	<el-table-column prop="projectId" label="项目ID"   :fixed="gd"  align="center" width="70">
				</el-table-column> -->
        <el-table-column
          prop="bm"
          label="项目编码"
          :fixed="gd"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="custName"
          label="客户名称"
          :fixed="gd"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="chanceType"
          label="商机类型"
          :fixed="gd"
          align="center"
          width="220"
        >
        <template slot="header">
          <el-select
            v-model="chanceType"
            placeholder="商机类型"
            size="mini"
            style="width: 100%; margin-right: 10px"
            clearable
            @change="onSearch"
          >
            <el-option
              v-for="item in chanceTypes"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          </template>
          <template slot-scope="scope">
            {{ chanceTypeName(scope.row.chanceType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          :fixed="gd"
          align="center"
          width="210"
        >
        </el-table-column>
        <!-- <el-table-column label="合同总金额" align="center" prop="incomexj" width="100">
				</el-table-column> -->
        <el-table-column
          label="合同总金额"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.incomexj - b.incomexj;
            }
          "
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.incomexj) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="回款总金额" align="center" prop="backmoneyxj" width="100">
				</el-table-column> -->
        <el-table-column
          label="回款总金额"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.backmoneyxj - b.backmoneyxj;
            }
          "
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.backmoneyxj) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="采购成本" align="center" prop="bmxj" width="100">
				</el-table-column> -->
        <el-table-column
          label="采购成本"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.bmxj - b.bmxj;
            }
          "
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.bmxj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="费用"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.costxj - b.costxj;
            }
          "
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.costxj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="税金"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.ratexj - b.ratexj;
            }
          "
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.ratexj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="保证金"
          align="center"
          sortable
          :sort-method="moneyXjSort"
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.moneyXj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="利润"
          align="center"
          sortable
          :sort-method="customSort"
          width="130"
        >
          <template #default="scope">
            <span>{{ moneyNumber(scope.row.profit) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createMan"
          label="业务负责人"
          align="center"
          width="150"
        >
          <template slot="header">
            <el-select
              v-model="createMan"
              placeholder="销售人员"
              size="mini"
              style="width: 100%; margin-right: 10px"
              clearable
              filterable
              @change="onSearch"
              :disabled="!qx"
            >
              <el-option
                v-for="item in createMans"
                :key="item.id"
                :label="item.uname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.createMan }}
          </template>
        </el-table-column>

        <el-table-column
          prop="techName"
          label="技术负责人"
          align="center"
          width="150"
        >
          <template slot="header">
            <el-select
              v-model="techLeaer"
              placeholder="技术负责人"
              size="mini"
              style="width: 100%; margin-right: 10px"
              clearable
              filterable
              @change="onSearch"
            >
              <!-- filterable multiple  @change="initRep"下拉框 多选   -->
              <el-option
                v-for="item in userType"
                :key="item.id"
                :label="item.uname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.techName }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" align="center" fixed="left" width="120"> -->
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              v-if="
                scope.row.stage < 10 && scope.row.cwjd != '1' && userId === '27'
              "
              >财务结单</el-button
            >
            <el-button
              type="danger"
              size="mini"
              :disabled="true"
              v-if="scope.row.stage == 12"
              >已关闭</el-button
            >
            <el-button
              type="danger"
              size="mini"
              :disabled="true"
              v-if="scope.row.stage == 11"
              >已丢标</el-button
            >
            <el-button
              type="danger"
              size="mini"
              :disabled="true"
              v-if="scope.row.stage == 10"
              >已结单</el-button
            >
            <el-button
              type="info"
              size="mini"
              :disabled="true"
              v-if="scope.row.cwjd == '1' && scope.row.stage != 10"
              >已财务结单</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column prop="stage" label="状态" align="center" width="100">
				</el-table-column> -->
      </el-table>

      <!-- 分页 2025.03.13 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 200, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page"
          :page-size="limit"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 结单 弹出框  dialogVisible:是否弹出 -->
    <el-dialog
      title="项目结单"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="inputObj.projectId"
                  placeholder="请选择"
                  size="mini"
                  disabled="true"
                  filterable
                  style="width: 350px"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="当前阶段" prop="stage">
                <el-tag>{{ inputObj.stageName }}</el-tag>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <span> 提示：按取消按钮终止，按确定按钮财务结单完成；</span>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
// 导出报表改用 exceljs（支持表头样式/列宽/数字格式/冻结首行）；不再使用 xlsx 的 DOM 导出

export default {
  name: "ProjRep",
  data() {
    return {
      userId: sessionStorage.getItem("userRoleId"),
      title: "",
      createMan: "",
      techLeaer: "",
      inputObj: {
        cwjd: "", // 财务结单
      },
      dialogVisible: false, // 结单 对话框
      loading: false, // 加载中
      reportData: [], // 存放查询结果
      createMans: [], // 负责人下拉框
      projectName: "",
      custName: "", //客户名称 查询用
      rqScope: "",
      gd: false,
      qx: false, // 若角色 为财务 27、系统管理员 1，总经理 8、销售总监 17 就置成true
      projectId: null,
      projects: [], //项目id-项目名称下拉框
      userType: [],
      page: 1,
      limit: 50,
      total: 0,
      routeParams: {},
      chanceTypes: [], //商机类型
      chanceType: "", //商机类型 查询用
    };
  },
  mounted() {
    this.initRepAll();
    this.quanxian();
    // 读取当前路由参数到 routeParams（不直接触发查询，查询由 projects 加载后触发）
    this.readRouteParams();
  },
  created() {
    this.initDim();
  },
  watch: {
    $route(to) {
      try {
        this.readRouteParams();
        if (to && to.query && to.query.projectId) {
          this.selectProjectFromRoute(to.query.projectId);
        }
      } catch (e) {
        // ignore
      }
    },
  },
  methods: {
    chanceTypeName(code) {
      let item = this.chanceTypes.find((item) => item.code == code);
      return item ? item.name : "";
    },
    // 读取当前路由的查询参数到 routeParams
    readRouteParams() {
      try {
        this.routeParams =
          this.$route && this.$route.query ? { ...this.$route.query } : {};
      } catch (e) {
        this.routeParams = {};
      }
      return this.routeParams;
    },
    // 简化版：等待 projects 加载后匹配路由传入的 project 标识并触发查询
    selectProjectFromRoute(projectCode, retries = 0) {
      if (!projectCode) return;

      this.projectId = Number(projectCode);
      this.initRep();
    },

    customSort(a, b) {
      if (a.profit < 0 && b.profit < 0) {
        return a.profit - b.profit;
      } else if (a.profit >= 0 && b.profit >= 0) {
        return a.profit - b.profit;
      } else {
        return a.profit < b.profit ? -1 : 1;
      }
    },
    moneyXjSort(a, b) {
      if (a.moneyXj < 0 && b.moneyXj < 0) {
        return a.moneyXj - b.moneyXj;
      } else if (a.moneyXj >= 0 && b.moneyXj >= 0) {
        return a.moneyXj - b.moneyXj;
      } else {
        return a.moneyXj < b.moneyXj ? -1 : 1;
      }
    },
    doAddRecord() {
      this.$refs["inputForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest2("/sale/cwjd", this.inputObj).then((resp) => {
            if (resp) {
              this.dialogVisible = false;
              this.initRepAll();
            }
          });
        }
      });
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (this.doesItContain([1, 8, 17, 27]).length > 0) {
          this.qx = true;
        }
      }
    },
    showEditView(data) {
      this.dialogVisible = true;
      this.inputObj = data;
    },
    doChance() {
      this.dialogVisible = false;
      this.initRepAll();
    },
    moneyNumber(val) {
      if (val == 0) {
        return "";
      } else {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    DetailRecordView(data) {
      let routeUrl = this.$router.resolve({
        path: "/proj/rep",
        query: { projectId: data.projectId },
      });
      window.open(routeUrl.href, "_blank");
    },
    shuaxin() {
      this.initRepAll();
      this.projectId = null;
    },
    // 导出用的列定义（表头 + 取值字段 + 列宽）
    // 说明：不再读 DOM，因此不会把筛选下拉框的选项文字混进表头；
    //      展开列与操作列（按钮）不导出。
    // 注意：这里比页面表格少 3 列，是有意精简（全量 757 行实测填充率）：
    //      税金 ratexj 1 行有值、合同总金额 incomexj 7 行、技术负责人 techName 22 行（仅 2 人）。
    //      页面表格仍保留这些列，仅导出不含；不要顺手加回来。
    getExportColumns() {
      return [
        { header: "项目编码", key: "bm", width: 16 },
        { header: "客户名称", key: "custName", width: 30 },
        {
          header: "商机类型",
          key: "chanceType",
          width: 12,
          format: (row) => this.chanceTypeName(row.chanceType),
        },
        { header: "项目名称", key: "projectName", width: 42 },
        { header: "回款总金额", key: "backmoneyxj", width: 15, money: true },
        { header: "采购成本", key: "bmxj", width: 15, money: true },
        { header: "费用", key: "costxj", width: 15, money: true },
        { header: "保证金", key: "moneyXj", width: 15, money: true },
        { header: "利润", key: "profit", width: 15, money: true },
        { header: "业务负责人", key: "createMan", width: 14 },
      ];
    },
    // 用数据数组生成 Excel（exceljs：支持表头样式、列宽、数字格式、冻结首行）
    // exceljs 体积较大，采用动态导入，仅在点击导出时才加载，不影响页面首屏
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "项目统计报表.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    async exportRowsToExcel(rows, fileName, sheetName) {
      const mod = await import(
        /* webpackChunkName: "exceljs" */ "exceljs"
      );
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS = mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const columns = this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 columns.header 自动生成）
      sheet.columns = columns.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };
      // 表头样式：加粗 + 灰底 + 居中 + 边框（与网页表头一致）
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFEEF1F6" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行，滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = columns.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        columns.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.key === "projectName" ? "left" : "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 导出数据：
    // 按当前筛选条件、以超大 limit 拉全量数据，直接用数据生成 Excel（不读 DOM）。
    // 因此不会出现「表头混入筛选下拉框选项」「多余空列」「无列宽」等问题。
    downloadExcel() {
      const EXPORT_LIMIT = 99999;
      const fileName = "项目统计报表_" + this.exportFileDate() + ".xlsx";
      this.loading = true;
      const url = this.buildRepParams({ page: 1, limit: EXPORT_LIMIT });

      this.getRequest(`/project/report_total?${url}`)
        .then((resp) => {
          const rows = (resp && resp.data) || [];
          this.loading = false;
          if (!rows.length) {
            this.$message({ type: "warning", message: "当前筛选条件下没有数据" });
            return;
          }
          // 导出失败不影响页面（数据未渲染到表格，无需还原分页状态）
          return this.exportRowsToExcel(rows, fileName).catch((e) => {
            console.log(e);
            this.$message({ type: "error", message: "导出失败，请重试" });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    // 拼装查询参数（供列表查询与导出共用，避免两处重复拼参导致条件不一致）
    buildRepParams(params = {}) {
      // 默认参数
      const defaultParams = {
        projectId: this.projectId,
        custName: this.custName,
        page: this.page,
        limit: this.limit,
        createMan: this.createMan,
        rqScope: this.rqScope,
        techLeaer: this.techLeaer,
        chanceType: this.chanceType,
      };

      // 合并参数，过滤掉空值（page/limit 允许传 0 以外的任意数字，单独判断）
      const queryParams = { ...defaultParams, ...params };
      return new URLSearchParams(
        Object.fromEntries(
          Object.entries(queryParams).filter(
            ([key, value]) =>
              value !== null &&
              value !== undefined &&
              value !== "" &&
              !(key === "page" && value === 0)
          )
        )
      );
    },
    // 把接口返回的数据写入表格（列表查询与导出共用）
    applyReportData(resp) {
      if (resp) {
        this.reportData = resp.data;
        this.total = resp.count;
      }
    },
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.initRep();
    },

    initRep(params = {}) {
      this.loading = true;

      const url = this.buildRepParams(params);

      this.getRequest(`/project/report_total?${url}`).then((resp) => {
        this.applyReportData(resp);
        this.loading = false;
      });
    },
    initRepAll() {
      this.initRep({ page: this.page, limit: this.limit });
    },
    initDim() {
      this.postRequest("/dim/dim_table_char/chance_type").then((resp) => {
        if (resp) {
          this.chanceTypes = resp.result;
          this.saveDictCache("chanceTypes", resp.result);
        }
      });
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project?flag=false").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
          // projects 加载后，如果路由带 projectId 则处理
          const projId =
            this.$route && this.$route.query && this.$route.query.projectId;
          if (projId) this.selectProjectFromRoute(projId);
        });
      } else {
        this.projects = this.dictCache("projects");
        const projId =
          this.$route && this.$route.query && this.$route.query.projectId;
        if (projId) this.selectProjectFromRoute(projId);
      }

      // 负责人 所有的销售人员
      if (!window.sessionStorage.getItem("createMans")) {
        this.getRequest("/user/queryAllSales").then((resp) => {
          if (resp) {
            this.createMans = resp;
            this.saveDictCache("createMans", resp);
          }
        });
      } else {
        this.createMans = this.dictCache("createMans");
      }
      // 所有技术负责人    this.getRequest("/user/queryAllUser")   this.getRequest("/user/queryAllTecher")
      if (!window.sessionStorage.getItem("allTecher")) {
        this.getRequest("/user/queryAllTecher").then((resp) => {
          if (resp) {
            this.userType = resp;
            this.saveDictCache("allTecher", resp);
          }
        });
      } else {
        this.userType = this.dictCache("allTecher");
      }
    },
    currentChange(currentPage) {
      console.log(currentPage);
      this.page = currentPage;
      this.initRep();
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initRep();
    },
  },
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
  margin-left: 40px;
}

/* 展开行的「标签」：这里只控制宽度/颜色。
   字号不在这里控制——label 由 Element 的 el-form-item 内部渲染，
   且本条(0,1,1)特异性输给全局层 .el-form-item--small .el-form-item__label(0,2,0)，
   标签实际是 14px，所以原先的 font-size: xx-small 已删除。 */
.demo-table-expand label {
  width: 90px;
  margin-left: 10px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 0;
  width: 25%;
}

/* 展开行的「值」：这是本页唯一真正生效的字号声明（span 在本组件模板里，选择器直接命中）。
   实测渲染 12px，比表体的 14px 小。 */
.demo-table-expand .myfont {
  font-size: xx-small;
}
</style>
